module.exports = __webpack_public_path__ + "img/Member.f0dc5074.svg";